export default {
    state: {
        selectedFilters: [],
        selectedFilterIds: []
    },
    getters: {
        getSelectedFilters(state) {
            return state.selectedFilters;
        },
        getSelectedFilterIds(state) {
            return state.selectedFilterIds;
        }
    },
    mutations: {
        pushFilter(state, filter) {
            state.selectedFilters.push(filter);
        },
        pushFilterId(state, id) {
            state.selectedFilterIds.push(id);
        },
        removeFilter(state, filter) {
            state.selectedFilters.splice(state.selectedFilters.indexOf(filter), 1)
        },
        removeFilterId(state, id) {
            state.selectedFilterIds.splice(state.selectedFilterIds.indexOf(id), 1)
        },
        clearSelectedFilters(state) {
            state.selectedFilters = [];
        },
        clearSelectedFilterIds(state) {
            state.selectedFilterIds = [];
        }
    },
    actions: {}
}